import React from "react";
import { message, Modal } from "antd";
import SyncJoySpaceController from "@/components/Joyspace/controllers/SyncJoySpaceController";
import "./index.less";
import events from "../../context/events";
const openErrorDeleteModal = (item: any) => {
  Modal.confirm({
    title: ``,
    content: "文件已损坏，无法完成上传",
    okText: "删除文件",
    okType: "danger",
    className: " modal-notitle",
    cancelText: "取消",
    async onOk() {
      console.log("删除本地离线文件");
      SyncJoySpaceController.removeDb(item.id);
      events.emit("list.syncReload");
    },
    onCancel() {}
  });
};

export default openErrorDeleteModal;
